<template>
        <v-list
        nav
        dense
        >
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="$store.state.backend_url+userinfor.image+'/'"></v-img>
          </v-list-item-avatar>
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-left">
              {{userinfor.name}}
              <v-list-item-subtitle >{{userinfor.title}}</v-list-item-subtitle>
              <v-list-item-subtitle >{{userinfor.email}}</v-list-item-subtitle>
              <v-list-item-subtitle >{{userinfor.phone_number}}</v-list-item-subtitle>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-btn small outlined class="grey--text text-capitalize" @click="$router.push({ name: 'BackgroundView' })">
                    <template>
                        <v-list-item-subtitle>
                            Hana's Background
                        </v-list-item-subtitle>
                    </template>
                </v-btn>
            </v-list-item-content>
        </v-list-item>
        <v-divider class="mx-1"/>
        <v-list-item @click="$router.push({ name: 'NoticeView' })">
            <v-list-item-content>
                <v-list-item-title>
                    공지사항
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider class="mx-1"/>
        <v-list-item @click="$router.push({ name: 'CalendarView' })">
            <v-list-item-content>
                <v-list-item-title>
                    교육일정
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider class="mx-1"/>
        <v-list-item @click="$router.push({ name: 'BookView' })">
            <v-list-item-content>
                <v-list-item-title>
                    Book List
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-divider class="mx-1"/>
        <div v-for="category in categorys" :key="category.id">
            <v-list-item @click="$router.push({ name: 'post' })">
                <v-list-item-content class="text-left">
                    <v-list-item-title>
                        {{ category.name }}
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon  @click="category.expansion=!category.expansion">
                        <v-icon>{{ category.expansion ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            
            <div v-if="category.expansion==true">
                <v-list-item v-for="sub_category in category.sub_categories" :key="sub_category.order">  
                        <v-btn class="text-capitalize" text @click="setSubCategory(sub_category)">
                            <template>
                                <v-list-item-content>
                                    <v-list-item-subtitle class="text-left">
                                    {{ sub_category.name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                
                            </template>
                        </v-btn>
                </v-list-item>
            </div>
            <v-divider class="mx-1"/>
        </div>
      </v-list>
</template>
<script>
import axios from 'axios'
  export default {
    data: () => ({
      research_field_view: false,
      references_view: false,
      developer_view: false,
      categorys: [],
      userinfor:{}
    }),
    mounted() {
        this.getCategory()
        this.getUserInfor()
    },
    methods:{
        getCategory(){
            axios
            .get('api/post/categories/')
            .then(res=>{
                this.categorys = res.data
                console.log(this.categorys)
            })
            .catch(err=>{
                console.log(err.data)
            })
        },
        getUserInfor(){
            axios
            .get('api/userinfor/user-info/1/')
            .then(res=>{
                this.userinfor = res.data
                // this.userinfor = res.data
            })
            .catch(err=>{
                console.log(err.data)
            })
        },
        setSubCategory(sub_category){
            this.$emit('setSubCategory', sub_category)
        },
        redirectToBookView() {
        // BookView 라우터로 이동
        this.$router.push({ name: 'BookView' });
        }
    }
  }
</script>
